import { Typography } from "@mui/material";

const ShortTextInputField = ({ value, onChange, charCount, readOnly, color }) => (
  <>
    <input
      style={{
        border: '1px solid #b8bdc9',
        borderRadius: '3px',
        padding: '10px',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: 1.45,
        color,
        marginBottom: '8px'
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
    <Typography variant="subtitle1" color="#b8bdc9">
      {charCount}/100
    </Typography>
  </>
);

export default ShortTextInputField;
